import { render, staticRenderFns } from "./meetsanta.vue?vue&type=template&id=67882068&scoped=true&"
import script from "./meetsanta.vue?vue&type=script&lang=js&"
export * from "./meetsanta.vue?vue&type=script&lang=js&"
import style0 from "./meetsanta.vue?vue&type=style&index=0&id=67882068&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67882068",
  null
  
)

export default component.exports